export default "/_next/static/images/e3f9e39ba99f8c2a3781b3c020723dc9.jpg";